"use client";
import { handleUpdateCartLineItem } from "@/components/PDP/ProductForm/_actions/addToCart";
import QuantityChanger from "@/components/QuantityChanger/QuantityChanger";
import { CartPhysicalItem, ProductData } from "@/lib/5874/types";
import { useSessionContext } from "@/lib/auth/SessionContextProvider";
import { useMasqueradeContext } from "@/lib/bigcommerce-b2b/masquerade/MasqueradeContextProvider";
import { StoreRegion } from "@/lib/_config/stores";
import { useCartContext } from "@/providers/CartContextProvider";
import { Form } from "@radix-ui/react-form";
import { FormProvider, useForm } from "react-hook-form";

interface Props {
	lineItem: CartPhysicalItem;
	className?: string;
	product: ProductData | undefined;
	store: StoreRegion;
}

export const UpdateQuantityForm = ({
	lineItem,
	className,
	product,
	store,
}: Props) => {
	const { setCart, setIsModifyingCart, cart } = useCartContext();
	const { session } = useSessionContext();
	const { masqueradingCompany } = useMasqueradeContext();
	const isMasquerading = masqueradingCompany?.id != null;

	const { handleSubmit, register, ...methods } = useForm();

	if (!lineItem) {
		return null;
	}

	const formSubmit = async (quantity: number) => {
		if (!session) return;
		setIsModifyingCart(true);
		const res = await handleUpdateCartLineItem(
			{ id: String(lineItem.product_id), quantity },
			lineItem,
			session,
		);

		if (res.status === "success") {
			setCart(res.data);
		}

		setIsModifyingCart(false);
	};

	return (
		<FormProvider handleSubmit={handleSubmit} register={register} {...methods}>
			<Form className={className}>
				<QuantityChanger
					cart={cart}
					product={product}
					minValue={1}
					isWhiteVersion
					value={lineItem.quantity}
					onChange={(quantity) => {
						methods.setValue("quantity", quantity);
						formSubmit(quantity);
					}}
					debounceTime={600}
				/>
			</Form>
		</FormProvider>
	);
};
